import type { PropsWithChildren } from 'react';

import { getAccountAccessRequestId } from '@utility/checkout-utils';

import { ScaAccountAccessContextProvider } from '../../contexts/ScaAccountAccessContext/ScaAccountAccessContext';
import { useJwtContext } from '../../hooks/useJwtContext/useJwtContext';

import type { ScaSubjectProviderProps } from './ScaSubjectProvider.types';

export const AccountAccessDetailsProvider = ({
  children,
  skip,
}: ScaSubjectProviderProps) => {
  const accountAccessId = getAccountAccessRequestId() ?? '';
  const { token: authToken } = useJwtContext();

  return (
    <ScaAccountAccessContextProvider
      accountAccessId={accountAccessId ?? ''}
      authToken={authToken ?? ''}
      enabled={Boolean(!skip && accountAccessId && authToken)}
    >
      {children}
    </ScaAccountAccessContextProvider>
  );
};

export const withAccountAccessDetailsProvider = ({
  children,
}: PropsWithChildren) => (
  <AccountAccessDetailsProvider>{children}</AccountAccessDetailsProvider>
);
